import { useCallback, useState } from 'react';
import { useToast } from '../components/toast/ToastContext';

export function useDispatchAction() {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const run = useCallback(async <T,>(label: string, fn: () => Promise<T>): Promise<T | null> => {
    setBusy(true);
    try {
      const result = await fn();
      toast.push({ tone: 'success', message: label + ' — done.' });
      return result;
    } catch (err) {
      toast.push({ tone: 'error', message: label + ' failed: ' + ((err as Error).message || 'unknown error') });
      return null;
    } finally {
      setBusy(false);
    }
  }, [toast]);

  return { run, busy };
}
